import * as React from 'react';
import { SVGProps } from 'react';

const IconWatchStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 7.5V3H7v5.541l4 2.669 1.147-1.639L9 7.5Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-2 0A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z"
    />
  </svg>
);
export default IconWatchStrokedSizeS;
